import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'

// Household membership changes when a user accepts an invite (their
// users.household_id is rewritten). The previous 60s staleTime meant that
// /home rendered the OLD household_id for up to a minute after accepting,
// blocking all dependent queries (pantry items, members, schedule). We
// rely on JoinHousehold/Join's invalidateQueries call to force a refetch
// the moment the accept succeeds, plus refetchOnMount so any later
// remount picks up the latest value too.
export function useHouseholdId(): string | null {
  const { user } = useAuth()
  const { data } = useQuery({
    queryKey:        ['householdId', user?.id],
    enabled:         !!user?.id,
    staleTime:       0,
    refetchOnMount:  'always',
    queryFn:         async () => {
      const { data } = await supabase
        .from('users')
        .select('household_id')
        .eq('id', user!.id)
        .maybeSingle()
      return (data?.household_id as string) ?? null
    },
  })
  return data ?? null
}
